import { Icon, Icons } from "../icon";
import * as styles from "./styles.css";
export const Spinner = ({ displayInCenterOfPage = false, }) => (React.createElement("div", { className: displayInCenterOfPage ? styles.spinnerInCenter : "" },
    React.createElement("div", { className: styles.spinnerWrapper },
        React.createElement(Icon, { type: Icons.CircularSpinner, className: styles.circularSpinner }))));

